import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { UrlHelperService } from '@core/services/url-helper.service';
import { BooleanResult } from '@core/interfaces/boolean-result.interface';
import { IFile } from '../collection/collection.component';
import { FileInfo } from '@progress/kendo-angular-upload';
import { ImageEntity } from "../../../shared/interfaces/entities/image.interface";

@Injectable()
export class CollectionService {

  constructor(private http: HttpClient, private urlHelper: UrlHelperService) { }

  openFile(id: number): Observable<Blob> {
    var url = this.urlHelper.getApiUrl() + "Collection/OpenFile/" + id;
    return this.http.get(url, { responseType: 'blob' });
  }

  openDocument(id: number): Observable<Blob> {
    var url = this.urlHelper.getApiUrl() + "CollectionDocument/OpenFile/" + id;
    return this.http.get(url, { responseType: 'blob' });
  }

  getCollectionImages(collectionId: string): Observable<Array<ImageEntity>> {
    var postData: { [k: string]: any } = {};
    postData['collectionId'] = collectionId;

    var url = this.urlHelper.getApiUrl() + "Collection/GetCollectionImages/?collectionId=" + collectionId;
    return this.http.get<any[]>(url);
  }

}
